<template>
  <div class="app-manage ghost-button-styles" v-if="pageVisiable">
    <el-form ref="form" :model="app" :rules="formRules" label-width="160px" class="app-form" @submit.native.prevent>
      <el-form-item label="平台" prop="platform" required>
        <el-radio-group v-model="app.platform" :disabled="editState" @change="platformChange">
          <el-radio-button ghost label="1">安卓应用</el-radio-button>
          <el-radio-button ghost label="2">iOS应用</el-radio-button>
          <el-radio-button ghost label="3">小程序</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="应用游戏选择" prop="gameId" required>
        <el-select
          v-model="app.gameId"
          filterable
          style="width: 400px"
          placeholder="请选择游戏"
          @change="onGameChange"
          :disabled="editState"
        >
          <el-option v-for="item in platformGameData" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="mediaPlatform.hasUC" label="APP包名" prop="packageName">
        <el-input v-model="app.packageName" style="width: 400px" disabled />
      </el-form-item>

      <el-form-item label="支持媒体" prop="mediaIds" required>
        <el-checkbox-group v-model="app.mediaIds">
          <el-checkbox-button ghost :label="10">巨量引擎</el-checkbox-button>
          <el-checkbox-button ghost :label="45">百度信息流</el-checkbox-button>
          <el-checkbox-button ghost :label="32" disabled>磁力引擎</el-checkbox-button>
          <el-checkbox-button ghost :label="6">超级汇川</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="媒体应用名称" prop="mediaGameName" required>
        <el-input
          v-model="app.mediaGameName"
          placeholder="显示在媒体后台的应用名称"
          maxlength="100"
          show-word-limit
          style="width: 400px"
        ></el-input>
      </el-form-item>

      <el-form-item label="应用图标" prop="appLogo" :required="mediaPlatform.hasBaidu">
        <app-upload
          v-model="app.appLogo"
          :max="1"
          :image-size="[450, 451]"
          :upload-url="uploadUrl"
          :allow-type="['image/png', 'image/jpeg']"
        />
        <p class="tips">图标需为方图，尺寸不小于512*512px，图标须为jpg/png格式</p>
      </el-form-item>

      <el-form-item v-if="mediaPlatform.hasUC" label="应用图标(UC)" prop="appLogoUc" required>
        <app-upload
          v-model="app.appLogoUc"
          :max="1"
          :image-size="[200, 200]"
          :upload-url="uploadUrl"
          :allow-type="['image/png', 'image/jpeg']"
        />
        <p class="tips">图标需为方图，尺寸为200*200px，图标须为jpg/png格式</p>
      </el-form-item>

      <template v-if="mediaPlatform.hasBaidu">
        <el-form-item label="应用截图" prop="appScreenshots" required>
          <app-upload
            v-model="app.appScreenshots"
            :max="6"
            :max-size="1"
            :image-size="[1, 1]"
            :upload-url="uploadUrl"
            :allow-type="['image/png', 'image/jpeg']"
          />
          <p class="tips">1. 请上传JPG/PNG格式竖版图片，单张图片需小于1MB</p>
          <p class="tips">2. 截图数量4-6张，且需保持尺寸一致，尺寸不小于480*800px</p>
          <p class="tips">3. 每张截图内容不能相同</p>
        </el-form-item>

        <el-form-item label="应用简介" prop="appIntroduce" required>
          <el-input
            type="textarea"
            v-model="app.appIntroduce"
            placeholder="应用简介，长度为50-1000"
            maxlength="1000"
            show-word-limit
            :rows="8"
            style="width: 400px"
          />
        </el-form-item>
      </template>

      <template v-if="mediaPlatform.hasUC">
        <el-form-item label="APP版本" prop="appVersion" required>
          <el-input v-model="app.appVersion" maxlength="100" show-word-limit style="width: 400px"></el-input>
        </el-form-item>

        <el-form-item label="更新时间" prop="opUpdateTime" required>
          <el-date-picker
            v-model="app.opUpdateTime"
            :picker-options="pickerOptions"
            :clearable="false"
            size="small"
            type="date"
            placeholder="请选择"
            style="width: 240px"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>

        <el-form-item label="应用权限" prop="appPermissions" required>
          <el-input v-model="app.appPermissions" maxlength="100" show-word-limit style="width: 400px"></el-input>
        </el-form-item>
      </template>

      <template v-if="mediaPlatform.hasBaidu || mediaPlatform.hasUC">
        <el-form-item label="隐私协议" prop="privateUrl" required>
          <el-input
            v-model="app.privateUrl"
            placeholder='隐私政策，暂只支持"http"、"https"类型的url，长度不超过500'
            maxlength="500"
            show-word-limit
            style="width: 400px"
          ></el-input>
        </el-form-item>

        <el-form-item label="开发者名称" prop="developerName" required>
          <el-input
            v-model="app.developerName"
            placeholder="和【计算机软件著作权登记证书】上著作权人一致，长度不超过100"
            maxlength="100"
            show-word-limit
            style="width: 400px"
          ></el-input>
        </el-form-item>
      </template>

      <template v-if="mediaPlatform.hasBaidu">
        <el-form-item label="主体证件号" prop="licenceNum" required>
          <el-input
            v-model="app.licenceNum"
            placeholder="请填写在工信部备案的主体证件号码"
            maxlength="100"
            show-word-limit
            style="width: 400px"
          ></el-input>
        </el-form-item>

        <el-form-item label="版权证明" prop="copyright">
          <app-upload
            v-model="app.copyright"
            :max="50"
            :max-size="10"
            :upload-url="uploadUrl"
            :allow-type="['image/png', 'image/jpeg', 'image/bmp', 'image/jpeg', 'application/pdf']"
          />
          <p class="tips">1. 可上传多份版权证明文件（最多不超过50份），可直接上传软件著作权文件</p>
          <p class="tips">2. 文件格式支持jpg、jpeg、bmp、png及pdf，每份文件大小不超过10MB</p>
        </el-form-item>

        <el-form-item label="版权补充说明">
          <el-switch v-model="app.licenceDescSwitch" />
        </el-form-item>

        <el-form-item v-if="app.licenceDescSwitch" prop="licenceDesc">
          <el-input
            type="textarea"
            v-model="app.licenceDesc"
            placeholder="版权补充说明，长度为5-1000"
            maxlength="1000"
            show-word-limit
            :rows="8"
            style="width: 352px"
          />
        </el-form-item>

        <el-form-item label="一句话描述" prop="summary">
          <el-input
            v-model="app.summary"
            placeholder="一句话描述，长度为2-60"
            maxlength="60"
            show-word-limit
            style="width: 400px"
          ></el-input>
        </el-form-item>

        <el-form-item label="应用分类" prop="appCategory">
          <el-select v-model="app.appCategory" filterable style="width: 400px" placeholder="全部">
            <el-option v-for="item in baiduGameCate" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>

        <el-form-item label="游戏题材" prop="baiduGameTheme">
          <el-cascader
            ref="baiduGameThemeRef"
            style="width: 400px"
            v-model="app.baiduGameTheme"
            :props="cascaderProps"
            :options="baiduGameThemeData"
            filterable
          ></el-cascader>
        </el-form-item>

        <el-form-item label="游戏玩法" prop="baiduGameType">
          <el-cascader
            ref="baiduGameTypeRef"
            style="width: 400px"
            v-model="app.baiduGameType"
            :props="cascaderProps"
            :options="baiduGameTypeData"
            filterable
          ></el-cascader>
        </el-form-item>

        <el-form-item label="测试账号" prop="testAccount">
          <el-input
            type="textarea"
            v-model="app.testAccount"
            placeholder="请输入测试账号和密码，并以英文分号隔开（账号和密码请勿加引号），最多不超过200个字符"
            maxlength="200"
            show-word-limit
            :rows="6"
            style="width: 400px"
          />
        </el-form-item>

        <el-form-item>
          <el-checkbox-group v-model="app.user">
            <el-checkbox label="0" disabled>我承诺保护用户隐私</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </template>

      <template v-if="app.platform === '3'">
        <el-form-item label="小程序原始id" prop="originId">
          <el-input v-model="app.originId" placeholder="请输入小程序原始id" maxlength="200" show-word-limit style="width: 400px"></el-input>
        </el-form-item>

        <el-form-item label="小程序appid" prop="wechatAppId">
          <el-input
            v-model="app.wechatAppId"
            placeholder="请输入小程序appid"
            maxlength="200"
            show-word-limit
            style="width: 400px"
          ></el-input>
        </el-form-item>
      </template>

      <template v-if="mediaPlatform.hasToutiao">
        <el-form-item label="头条小程序回调url" prop="wechatCbUrl">
          <el-input
            v-model="app.wechatCbUrl"
            placeholder="请输入头条小程序回调url"
            maxlength="200"
            show-word-limit
            style="width: 400px"
          ></el-input>
          <el-tooltip effect="dark" placement="top">
            <div slot="content">
              <p style="margin-bottom: 6px">
                在巨量引擎投放必填，否则平台侧收不到数据回传！ 路径：<strong>巨量工作台-资产-小程序&小游戏-转化上报-复制url&token</strong>
              </p>
              <el-image
                style="width: 650px"
                src="https://ptom-resource-cos.caohua.com/ptom/advResource/image/f6cb04dac9b60ed9f0a0f67419ca5f0e.png"
              ></el-image>
            </div>
            <span style="margin-left: 10px" class="el-icon-warning-outline">填写指引</span>
          </el-tooltip>
        </el-form-item>

        <el-form-item label="头条小程序回调Token" prop="wechatToken">
          <el-input
            v-model="app.wechatToken"
            placeholder="请输入头条小程序回调Token"
            maxlength="200"
            show-word-limit
            style="width: 400px"
          ></el-input>
        </el-form-item>
      </template>

      <el-form-item>
        <el-button @click.stop="cannel">取消</el-button>
        <el-button type="primary" v-if="editState" :loading="submitLoading" @click.stop="submit(0)">
          <span>更新</span>
        </el-button>
        <el-button type="primary" v-else :loading="submitLoading" @click.stop="submit(1)">
          <span>提交</span>
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import moment from 'moment'
import { isArray, timeout } from '@/common/js/utils'
import { getAppInfo, addOrUpdateAppInfo } from '@/api/manage.model'
import { getCaoHuaGames } from '@/api/common.model'
import appUpload from './components/app-upload.vue'
import { findAppInfoById, addOrUpdateAppinfoMedia } from '@/api/sysmana.model'
import { MEDIAS } from '@/common/js/constants.js'

export default {
  name: 'appAdd',
  components: { appUpload },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    title() {
      return this.editState ? '修改游戏应用' : '新增游戏应用'
    },
    mediaPlatform() {
      const mediaIds = this.app && isArray(this.app.mediaIds) && this.app.mediaIds
      return {
        hasBaidu: mediaIds.includes(MEDIAS.BAIDU),
        hasToutiao: mediaIds.includes(MEDIAS.TOUTIAO),
        hasUC: mediaIds.includes(MEDIAS.UC)
      }
    },
    platformGameData() {
      return this.gameList.filter((ret) => `${ret.ch_platform_id}` === `${this.app.platform}`)
    },
    formRules() {
      const rules = {
        platform: [{ required: true, message: '请选择平台', trigger: 'change' }],
        gameId: [{ required: true, message: '请选择游戏', trigger: 'change' }],
        mediaIds: [{ required: true, message: '请选择支持媒体', trigger: 'change' }],
        mediaGameName: [
          { required: true, message: '请输入媒体应用名称', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        appCategory: [{ required: true, message: '请选择应用分类', trigger: 'change' }],
        baiduGameType: [
          { required: true, type: 'array', message: '请选择游戏玩法', trigger: 'change' },
          { type: 'array', min: 1, message: '请选择一个游戏题材' }
        ],
        baiduGameTheme: [
          { required: true, message: '请选择游戏题材', trigger: 'change' },
          { type: 'array', min: 1, message: '请选择一个游戏题材' }
        ],
        appLogo: [],
        appLogoUc: [],
        appScreenshots: [],
        appIntroduce: [],
        appVersion: [],
        opUpdateTime: [],
        appPermissions: [],
        privateUrl: [],
        developerName: [],
        licenceNum: [],
        summary: [],
        licenceDesc: [],
        testAccount: [{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }]
      }

      if (this.mediaPlatform.hasBaidu) {
        rules.appLogo.push({ required: true, message: '请上传应用图标', trigger: 'change' })
        rules.appScreenshots.push(
          { required: true, message: '请上传应用截图', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (!value) return callback(new Error('请上传应用截图'))
              const list = value.split(',')
              if (list.length < 4 || list.length > 6) {
                return callback(new Error('截图数量4-6张'))
              }
              callback()
            },
            trigger: 'change'
          }
        )
        rules.appIntroduce.push(
          { required: true, message: '请输入应用简介', trigger: 'blur' },
          { min: 50, max: 1000, message: '长度在 50 到 1000 个字符', trigger: 'blur' }
        )
        rules.licenceNum.push({ required: true, message: '请输入主体证件号', trigger: 'blur' })
        rules.summary.push({ min: 2, max: 60, message: '长度在 2 到 60 个字符', trigger: 'blur' })
        rules.privateUrl.push({ required: true, message: '请输入隐私协议URL', trigger: 'blur' })
        rules.developerName.push({ required: true, message: '请输入开发者名称', trigger: 'blur' })
      }

      if (this.mediaPlatform.hasUC) {
        rules.appLogoUc.push({ required: true, message: '请上传应用图标(UC)', trigger: 'change' })
        rules.appVersion.push({ required: true, message: '请输入APP版本', trigger: 'blur' })
        rules.opUpdateTime.push({ required: true, message: '请选择更新时间', trigger: 'change' })
        rules.appPermissions.push({ required: true, message: '请输入应用权限', trigger: 'blur' })
        if (!rules.privateUrl.length) {
          rules.privateUrl.push({ required: true, message: '请输入隐私协议URL', trigger: 'blur' })
        }
        if (!rules.developerName.length) {
          rules.developerName.push({ required: true, message: '请输入开发者名称', trigger: 'blur' })
        }
      }

      if (this.app.licenceDescSwitch) {
        rules.licenceDesc.push(
          { required: true, message: '请输入版权补充说明', trigger: 'blur' },
          { min: 5, max: 1000, message: '长度在 5 到 1000 个字符', trigger: 'blur' }
        )
      }

      return rules
    }
  },
  methods: {
    getData(id) {
      const appInfo = this.devGameId ? findAppInfoById({ devGameId: id }) : getAppInfo({ id })
      appInfo.then((data) => {
        if (data) {
          Object.keys(data).forEach((key) => {
            if (data[key] === null) delete data[key]
          })
          let { platform, opUpdateTime, mediaIds, licenceDesc, cateGoryInfo } = data
          const licenceDescSwitch = !!licenceDesc

          let baiduGameTheme = []
          let baiduGameType = []
          if (cateGoryInfo && cateGoryInfo.startsWith('[')) {
            const info = JSON.parse(cateGoryInfo)
            const [baiduGameThemeTree, baiduGameTypeTree] = info[0].children
            baiduGameTheme = this.getPath([baiduGameThemeTree])
            baiduGameType = this.getPath([baiduGameTypeTree])
          }

          if (platform) platform += ''
          else if (isArray(this.gameList) && this.gameList.length) {
            const gameId = this.gameList.filter((ret) => ret.id === data.gameId)
            platform = gameId[0].ch_platform_id.toString()
          }
          if (opUpdateTime) opUpdateTime = moment(opUpdateTime).format('YYYY-MM-DD')
          Object.assign(this.app, data, {
            mediaIds: mediaIds.split(',').map(Number),
            baiduGameType,
            baiduGameTheme,
            licenceDescSwitch,
            platform,
            opUpdateTime
          })
          this.$nextTick(() => {
            this.pageVisiable = true
          })
        }
      })
    },
    getPath(node) {
      let ids = []
      const nodes = Array.isArray(node) ? node : [node]
      nodes.forEach((item) => {
        if (item) {
          if (item.id) ids.push(item.id)
          if (item.children && item.children.length) {
            ids = ids.concat(this.getPath(item.children))
          }
        }
      })
      return ids
    },
    preload() {
      const { id, devGameId } = this.$route.query
      this.devGameId = devGameId

      fetch('/data/baidu_game_theme.json')
        .then((res) => res.json())
        .then((treeData) => {
          this.baiduGameThemeData = treeData
        })

      fetch('/data/baidu_game_type.json')
        .then((res) => res.json())
        .then((treeData) => {
          this.baiduGameTypeData = treeData
        })
      Promise.all([getCaoHuaGames()])
        .then((data) => {
          const [game] = data
          isArray(game) && (this.gameList = game)
          if (id || devGameId) this.getData(id || Number(devGameId))
          else this.pageVisiable = true
        })
        .catch((err) => {
          this.$message.error(err.message || 'Error')
        })
    },
    submit(next) {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.$message.error('请检查表单填写')
          return
        }

        const { baiduGameType, baiduGameTheme, ...restAppParams } = this.app

        const { devGameId } = this.$route.query
        if (!restAppParams.licenceDescSwitch) {
          restAppParams.licenceDesc = null
        }

        if (this.mediaPlatform.hasBaidu) {
          const [baiduGameThemeNode] = this.$refs.baiduGameThemeRef.getCheckedNodes()
          const [baiduGameTypeNode] = this.$refs.baiduGameTypeRef.getCheckedNodes()
          const baiduGameThemePathNodes = baiduGameThemeNode.pathNodes.map((i) => i.data)
          const baiduGameTypePathNodes = baiduGameTypeNode.pathNodes.map((i) => i.data)

          // 把节点组成树形结构
          const baiduGameThemeTree = baiduGameThemePathNodes.reduceRight((acc, cur) => {
            cur.children = []
            if (acc !== null) {
              cur.children = [acc]
            }
            return cur
          }, null)

          const baiduGameTypeTree = baiduGameTypePathNodes.reduceRight((acc, cur) => {
            cur.children = []
            if (acc !== null) {
              cur.children = [acc]
            }
            return cur
          }, null)
          // https://dev2.baidu.com/content?sceneType=0&pageId=100436&nodeId=418&subhead=%E5%BA%94%E7%94%A8%E5%88%86%E7%B1%BB%EF%BC%88%E6%96%B0%EF%BC%89
          restAppParams.cateGoryInfo = [
            {
              ...this.baiduGameCate[0],
              children: [baiduGameThemeTree, baiduGameTypeTree]
            }
          ]
        }

        const params = Object.assign({}, restAppParams)

        if (!this.mediaPlatform.hasToutiao) {
          delete params.wechatToken
          delete params.wechatCbUrl
        }

        if (restAppParams.platform !== '3') delete params.wechatAppId
        const arrsToStr = ['mediaIds']
        arrsToStr.forEach((key) => {
          if (isArray(params[key])) params[key] = params[key].join(',')
        })

        if (next) {
          params.id = undefined // 新建
          params.flag = 1
        }
        this.submitLoading = true
        const submitParams = devGameId ? addOrUpdateAppinfoMedia(params) : addOrUpdateAppInfo(params)
        submitParams
          .then((data) => {
            this.submitLoading = false
            if (data) {
              this.$message.success('操作成功')
              timeout(1000).then(() => {
                this.jump()
              })
            }
          })
          .catch(() => {
            this.submitLoading = false
          })
      })
    },
    onGameChange(id) {
      const meta = this.platformGameData.find((g) => g.id === id)
      if (meta) {
        this.app.appLogo = meta.icon
        this.app.packageName = meta.ad_package
      }
    },
    platformChange() {
      this.app.gameId = ''
      this.app.packageName = ''
    },
    cannel() {
      this.$confirm('关闭当前页面编辑信息将丢失，是否确定？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.jump()
        })
        .catch(() => {})
    },
    jump() {
      this.$router.push({ name: 'appslist' })
    }
  },
  data() {
    return {
      pageVisiable: false,
      submitLoading: false,
      baiduGameCate: [{ id: 317000, name: '游戏' }],
      baiduGameThemeData: [],
      baiduGameTypeData: [],
      app: {
        platform: '1',
        gameId: null,
        mediaIds: [MEDIAS.TOUTIAO],
        appLogo: '',
        appLogoUc: '',
        appScreenshots: '',
        appIntroduce: '',
        appVersion: '',
        opUpdateTime: '',
        appPermissions: '',
        privateUrl: '',
        developerName: '',
        licenceNum: '',
        copyright: '',
        licenceDescSwitch: false,
        licenceDesc: '',
        summary: '',
        category: '',
        tags: '',
        testAccount: '',
        originId: '',
        wechatAppId: '',
        wechatCbUrl: '',
        wechatToken: '',
        packageName: '',
        mediaGameName: '',
        user: ['0'],
        appCategory: 317000,
        baiduGameTheme: [],
        baiduGameType: []
      },
      gameList: [],
      devGameId: '',
      uploadUrl: '/api/ptom/appinfo/uploadAppImage',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      cascaderProps: {
        // checkStrictly: true,
        label: 'name',
        value: 'id'
      }
    }
  },
  created() {
    this.preload()
  }
}
</script>

<style lang="scss" scoped>
.app-manage {
  background: #fff;
}
.app-form {
  height: calc(100vh - 170px);
  overflow: auto;
}
.tips {
  font-size: 12px;
  color: #999;
  line-height: 1.5;
  margin-top: 5px;
}
</style>
